/** @format */

import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'homefield-global-chips',
  templateUrl: './global-chips.component.html',
  styleUrl: './global-chips.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldGlobalChipsComponent {
  @Input()
  public label: string;

  @Input()
  public showCancelSign: boolean;

  @Input()
  public isSelected: boolean;

  /**
   * Determine whether or not to show selected user zipcode or selected user store info
   */
  @Input()
  public shouldShowLocation: string;

  @Input()
  public selectedStoreName: string;

  @Input()
  public selectUserZipCode: string;

  @Output() removeFilter: EventEmitter<any> = new EventEmitter();

  visibleFilter = false;

  toggleFilter() {
    this.visibleFilter = !this.visibleFilter;
    if (this.visibleFilter) {
      this.removeFilter.emit(null);
    }
  }
}
